<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">{{ isCreate() ? 'Add' : 'Edit' }} Domain</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" id="form">
    <div class="row g-3">

      <div class="col-12">
        <label for="domain" class="form-label">Domain Name</label>
        <input type="text" id="domain" class="form-control" placeholder="Enter a domain"
          formControlName="domain">
      </div>

      <div class="col-12">
        <label for="productId" class="form-label">Brand</label>
        <select class="form-select" id="productId" formControlName="productId">
          <option [ngValue]="null">All</option>
          @for (product of products; track product) {
            <option [ngValue]="product.id">{{ product.name }}</option>
          }
        </select>
      </div>

      <div class="col-12">
        <div class="form-check">
          <input type="radio" id="partner-all" class="form-check-input" formControlName="partnerId" [value]="null">
          <label for="partner-all" class="form-check-label">All partner</label>
        </div>

        <div class="form-check">
          <input type="radio" id="partner-current" class="form-check-input" formControlName="partnerId"
            [value]="$safeNavigationMigration(partner?.id)">
          <label for="partner-current" class="form-check-label">Only this partner ({{ partner }})</label>
        </div>
      </div>

    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>
  @if (isCreate()) {
    <button form="form" type="submit" class="btn btn-primary fw-bold">Create</button>
  }
  @if (!isCreate()) {
    <button form="form" type="submit" class="btn btn-primary fw-bold">Update</button>
  }
</div>
